module.exports = __webpack_public_path__ + "8b9417b2ace251fb9482f89d07fe9592.pdf";